import { FC } from 'react';

import { ADTO } from '@helpful/network';
import { VisitSummary } from '@common/features';

interface ContentEncounterProps {
  encounter: ADTO.EncounterEntity;
}

export const ContentEncounter: FC<ContentEncounterProps> = ({ encounter }) => {
  return <VisitSummary {...encounter} />;
};
